<template>
    <div class="modal micromodal-slide" :id="id" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-1-title">
                <div class="modal__search_input">
                    <input type="text" :placeholder="placeholder" v-on:keyup="search" v-model="searchTerm">
                    <i class="modal__search_input__clear search-input__clear--active icon ion-md-close"></i>
                </div>
                <div class="modal__content" id="modal-1-content">
                    <ul class="itemlist">
                        <li v-for="(result, index) in searchResults">
                            <avatar :user="result"></avatar>
                            <div class="itemlist__detail">{{ result.name }}</div>
                            <button class="btn btn-small" v-on:click.stop.prevent="addItem(index)" v-if="!userAlreadySelected(result.id)">{{buttonText}}</button>
                            <span v-if="userAlreadySelected(result.id)">{{buttonTextComplete}}</span>
                        </li>
                    </ul>
                </div>
                <footer class="modal__footer">
                  <a class="btn" data-micromodal-close aria-label="Close this dialog window">Close</a>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import MicroModal from 'micromodal';
    export default {
        props: {
            id: {
                default: "modal-1",
            },
            placeholder: {
                default: "Type the name of the person to add",
            },
            users:{
                default: []
            },
            buttonText:{
                default: "Add User"
            },
            buttonTextComplete:{
                default: "User Added"
            }
        },
        data () {
            return {
                searchTerm: '',
                searchResults: []
            }
        },
        mounted() {
            MicroModal.init();
        },
        computed: {
        },
        methods: {
            userAlreadySelected: function (userId) {
                if(  this.users.filter(user=>user.id === userId).length > 0 ){
                    return true
                }else{
                    return false;
                }
            },
            addItem(index){
                this.$emit(this.id + '-add-item', this.searchResults[index]);
            },
            search(){
                this.$nextTick(() => {
                    if (this.searchTerm.length === 0) {
                        this.searchResults = [];
                    }

                    if (this.searchTerm.length > 1) {
                        axios.get('/api/account/users/search?q=' + this.searchTerm).then((response) => {
                            this.searchResults = response.data;
                        }, (response) => {
                            this.error = response;
                        });
                    }


                });
            }
        }
    }
</script>


<style lang="scss">
    .itemlist{
        list-style: none;
        padding: 10px 0;

        li{
            display: flex;
            align-items: flex-start;
            margin-bottom: 10px;
        }

        &__detail{
            flex-grow: 1;
            margin-left: 10px;
        }
    }

    .modal {
        &__overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 99;
        }

        &__search_input{
            position: relative;

            &:before {
                font-family: Ionicons;
                content: "";
                color: #ccc;
                position: absolute;
                height: 24px;
                top: 50%;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
                font-size: 22px;
                left: 20px;
            }

            input{
                font-size: 16px;
                line-height: 22px;
                padding: 15px;
                padding-left: 50px;
                padding-right: 50px;
                background: rgb(245, 246, 247);
                width: 100%;
                border: 0;
                outline: none;
                box-shadow: none;
                &:focus{
                    border: none;
                    box-shadow: none;
                }
            }

            &__clear {
                -webkit-transition: background .3s,opacity .3s;
                transition: background .3s,opacity .3s;
                position: absolute;
                top: 50%;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
                right: 16px;
                font-size: 14px;
                width: 22px;
                height: 22px;
                display: -ms-flexbox;
                display: flex;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-pack: center;
                justify-content: center;
                cursor: pointer;
                color: #ccc;
                opacity: 0;
                background-color: #ccc;
                border-radius: 100px;

                &:hover {
                    opacity: 1;
                    background-color: #e3e9f3;
                }
            }

        }

        &__container {
          background-color: #fff;
          padding: 0;
          max-width: 500px;
          min-width: 480px;
          max-height: 100vh;
          border-radius: 4px;
          overflow-y: auto;
          box-sizing: border-box;
        }

        &__header {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .modal__close:before { content: "\2715"; }
        }

        &__title {
          margin-top: 0;
          margin-bottom: 0;
          font-weight: 600;
          font-size: 1.25rem;
          line-height: 1.25;
          color: #00449e;
          box-sizing: border-box;
        }

        &__close {
          background: transparent;
          border: 0;
        }
        
        &__content {
            padding: 0 20px;
            margin-top: 20px;
            margin-bottom: 20px;
            line-height: 1.5;
            color: rgba(0,0,0,.8);
            min-height: 100px;
        }

        &__btn {
          font-size: .875rem;
          padding-left: 1rem;
          padding-right: 1rem;
          padding-top: .5rem;
          padding-bottom: .5rem;
          background-color: #e6e6e6;
          color: rgba(0,0,0,.8);
          border-radius: .25rem;
          border-style: none;
          border-width: 0;
          cursor: pointer;
          -webkit-appearance: button;
          text-transform: none;
          overflow: visible;
          line-height: 1.15;
          margin: 0;
          will-change: transform;
          -moz-osx-font-smoothing: grayscale;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          -webkit-transform: translateZ(0);
          transform: translateZ(0);
          transition: -webkit-transform .25s ease-out;
          transition: transform .25s ease-out;
          transition: transform .25s ease-out,-webkit-transform .25s ease-out;
        }
    }

    .modal__btn:focus, .modal__btn:hover {
      -webkit-transform: scale(1.05);
      transform: scale(1.05);
    }

    .modal__btn-primary {
      background-color: #00449e;
      color: #fff;
    }

    /**************************\
      Demo Animation Style
    \**************************/
    @keyframes mmfadeIn {
        from { opacity: 0; }
          to { opacity: 1; }
    }

    @keyframes mmfadeOut {
        from { opacity: 1; }
          to { opacity: 0; }
    }

    @keyframes mmslideIn {
      from { transform: translateY(15%); }
        to { transform: translateY(0); }
    }

    @keyframes mmslideOut {
        from { transform: translateY(0); }
        to { transform: translateY(-10%); }
    }

    .micromodal-slide {
      display: none;
        &.is-open {
          display: block;
        }
    }


    .micromodal-slide[aria-hidden="false"] .modal__overlay {
      animation: mmfadeIn .3s cubic-bezier(0.0, 0.0, 0.2, 1);
    }

    .micromodal-slide[aria-hidden="false"] .modal__container {
      animation: mmslideIn .3s cubic-bezier(0, 0, .2, 1);
    }

    .micromodal-slide[aria-hidden="true"] .modal__overlay {
      animation: mmfadeOut .3s cubic-bezier(0.0, 0.0, 0.2, 1);
    }

    .micromodal-slide[aria-hidden="true"] .modal__container {
      animation: mmslideOut .3s cubic-bezier(0, 0, .2, 1);
    }

    .micromodal-slide .modal__container,
    .micromodal-slide .modal__overlay {
      will-change: transform;
    }
</style>